"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAssetUrl = void 0;

var buildAssetUrl = function buildAssetUrl(config, id, options, version) {
  var size = options.height && options.width ? "&width=".concat(options.width, "&height=").concat(options.height) : "";
  var versionQs = version ? "&version=".concat(version) : "";
  return "".concat(config.baseUrl, "/api/assets/").concat(config.appName, "/").concat(id, "?mode=Min&nofocus").concat(size).concat(versionQs, "&scope=all");
};

exports.buildAssetUrl = buildAssetUrl;